import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import type { Stack } from '../../../../packages/data/structures/Stack';
import type { BaseSettingsScreen } from '../screen/BaseSettingsScreen';

import type { BasicParametersEntity } from './BasicParameters.entity';
import styles from './BasicParameters.module.scss';
import { BasicParametersStore } from './BasicParameters.store';
import { ActionsPanel } from './components/ActionsPanel';
import { HeaderSection } from './components/HeaderSection';
import { ParametersGrid } from './components/ParametersGrid';

type Props = {
  stack: Stack<BaseSettingsScreen>;
  screen: BasicParametersEntity;
  config?: {
    wellId?: number;
    wellboreId?: number;
  };
};

export const BasicParameters = observer(function BasicParameters({ stack, screen, config }: Props) {
  const [store, setStore] = useState<BasicParametersStore | null>(null);

  useEffect(() => {
    if (store) return;

    const newStore = new BasicParametersStore(stack, screen, config);
    setStore(newStore);
  }, [stack, screen, config, store]);

  useEffect(() => {
    if (store && !store.isInitialised) {
      store.fetchWells();
    }
  }, [store]);

  if (!store) return null;

  const { isWellLogsLoading, currentWellbore } = store;
  const isDisabled = !currentWellbore || isWellLogsLoading;

  return (
    <article className={styles.column}>
      <HeaderSection store={store} screen={screen} />
      <ActionsPanel store={store} disabled={isDisabled} />
      <ParametersGrid store={store} disabled={isDisabled} />
    </article>
  );
});
